module.exports = __webpack_public_path__ + "img/10.39eb7756.svg";